import React, { useState, useEffect } from 'react';
import { Column, Editing } from "devextreme-react/data-grid";
import { Icon } from "@iconify/react";


// Sample user data for table
const userData = [
  { id: 1, name: 'MAHINDRA XYLO', type: 'Preventive', due: '17-Jun-2025' },
  { id: 2, name: 'I-Girder Shutter', type: 'Corrective', due: '15-Jun-2025' },
  { id: 3, name: 'Pier Cap Shutter ', type: 'Break Down', due: '12-Jun-2025' },
  { id: 4, name: 'Pier Cap Shutter ', type: 'Repaired', due: '12-Jun-2025' },
  { id: 5, name: 'ISUZU', type: 'Scrap', due: '12-Jun-2025' },

];

// Metrics data
const cardData = [
  { title: 'Active Asset', value: '1,50,00,000', icon: <Icon icon="icon-park-outline:active" color="primary" /> },
  { title: 'Scrap Asset', value: '18,982', icon: <Icon icon="icon-park-outline:close-one" color="error" /> },
  { title: 'Count ', value: '1050', icon: <Icon icon="icon-park-outline:trending-up" color="warning" /> },
];

const Dashboard = () => {
  const [openSidebar, setOpenSidebar] = useState(true);
  const handleSidebarToggle = () => {
    setOpenSidebar(!openSidebar);
  };

  return <>
    <div className="content">
      <div className="filter-date mb-3">
        <span class="badge badge-pill badge-outline-primary mr-2"><Icon icon="material-symbols:today-outline" className="iconify-size" /> Today</span>
        <span class="badge badge-pill badge-outline-primary mr-2"><Icon icon="cuida:calendar-outline" className="iconify-size" /> Week</span>
        <span class="badge badge-pill badge-outline-primary mr-2"><Icon icon="material-symbols:calendar-month-outline-rounded" className="iconify-size" /> Month</span>
        <span class="badge badge-pill badge-outline-primary mr-2"><Icon icon="iwwa:year" className="iconify-size" /> Year</span>
        <span class="badge badge-pill badge-outline-primary mr-2"><Icon icon="ion:today-outline" className="iconify-size" /> Custom</span>
      </div>
      <div className="count mb-3">
        <div className="count-box">
          <table width="100%">
            <tr>
              <td className="icon">
                <Icon icon="iconoir:multiple-pages" className="iconify-size" />
              </td>
              <td className="content">
                <div className="title">Total Assets</div>
                <div className="number">2000</div>
              </td>
            </tr>
          </table>
        </div>
        <div className="count-box">
          <table width="100%">
            <tr>
              <td className="icon">
                <Icon icon="gg:add" className="iconify-size" />
              </td>
              <td className="content">
                <div className="title">New</div>
                <div className="number">500</div>
              </td>
            </tr>
          </table>
        </div>
        <div className="count-box">
          <table width="100%">
            <tr>
              <td className="icon">
                <Icon icon="charm:circle-tick" className="iconify-size" />
              </td>
              <td className="content">
                <div className="title">Dumped</div>
                <div className="number">100</div>
              </td>
            </tr>
          </table>
        </div>
        <div className="count-box">
          <table width="100%">
            <tr>
              <td className="icon">
                <Icon icon="mingcute:delete-2-line" className="iconify-size" />
              </td>
              <td className="content">
                <div className="title">Scrapped</div>
                <div className="number">50</div>
              </td>
            </tr>
          </table>
        </div>

        <div className="count-box">
          <table width="100%">
            <tr>
              <td className="icon">
                <Icon icon="cuida:calendar-outline" className="iconify-size" />
              </td>
              <td className="content">
                <div className="title">Maintenance</div>
                <div className="number">150</div>
              </td>
            </tr>
          </table>
        </div>
        <div className="count-box">
          <table width="100%">
            <tr>
              <td className="icon">
                <Icon icon="icon-park-outline:close-one" className="iconify-size" />
              </td>
              <td className="content">
                <div className="title">Not in Use</div>
                <div className="number">100</div>
              </td>
            </tr>
          </table>
        </div>
        <div className="count-box">
          <table width="100%">
            <tr>
              <td className="icon">
                <Icon icon="charm:circle-tick" className="iconify-size" />
              </td>
              <td className="content">
                <div className="title">Active</div>
                <div className="number">100</div>
              </td>
            </tr>
          </table>
        </div>

      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="card">
            <div className="card-header">
              <div className="card-title">Assets by Status</div>
            </div>
            <div class="card-body text-center">
              <img src="./assets/img/donut.png" className="img-fluid" width="500px"/>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="card">
            <div className="card-header">
              <div className="card-title">Assets by Category</div>
            </div>
            <div class="card-body text-center">
              <img src="./assets/img/barchart.png" className="img-fluid" width="550px"/>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <div className="card-title">Assets</div>

        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-bordered custom-table-ui">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Serial #</th>
                  <th>Group</th>
                  <th>Category</th>
                  <th>Type</th>
                  <th>Location</th>
                  <th>Activity</th>
                  <th>Action Taken On</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>ABC Product</td>
                  <td>S123456</td>
                  <td>Group A</td>
                  <td>Hardware</td>
                  <td>Electrical</td>
                  <td>Warehouse 5</td>
                  <td>Inspection Completed</td>
                  <td>2024-12-18</td>
                  <td>Active</td>
                </tr>
                <tr>
                  <td>Hydraulic Pump</td>
                  <td>S00123</td>
                  <td>Mechanical</td>
                  <td>Machinery</td>
                  <td>Component</td>
                  <td>Plant 1</td>
                  <td>Maintenance Completed</td>
                  <td>2025-05-10</td>
                  <td>Active</td>
                </tr>
                <tr>
                  <td>Power Cable</td>
                  <td>S00456</td>
                  <td>Electrical</td>
                  <td>Wiring</td>
                  <td>Spare</td>
                  <td>Depot B</td>
                  <td>Installed</td>
                  <td>2025-03-27</td>
                  <td>In Use</td>
                </tr>
                <tr>
                  <td>Control Panel</td>
                  <td>S00789</td>
                  <td>Automation</td>
                  <td>Panel</td>
                  <td>Asset</td>
                  <td>Warehouse</td>
                  <td>Inspection Scheduled</td>
                  <td>2025-06-15</td>
                  <td>Pending</td>
                </tr>
                <tr>
                  <td>Conveyor Belt</td>
                  <td>S01001</td>
                  <td>Production</td>
                  <td>Transport</td>
                  <td>Assembly</td>
                  <td>Floor 2</td>
                  <td>Repaired</td>
                  <td>2025-04-12</td>
                  <td>Operational</td>
                </tr>
                <tr>
                  <td>Fire Alarm System</td>
                  <td>S01578</td>
                  <td>Safety</td>
                  <td>Security</td>
                  <td>Device</td>
                  <td>Main Building</td>
                  <td>Replaced</td>
                  <td>2025-02-06</td>
                  <td>Working</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </>;
}

export default Dashboard;
